import { Children } from 'react';
import { toCssLength, getJustifyCssValue, defaultJustifyFor } from '../variables/containerLayoutTypes';

// Dumb presentational layout engine shared by both container systems
// (Topic-level TopicContainer + Exercise-level ExerciseTemplateContainer) -
// turns {layout, config} into a CSS class + custom properties. No edit-vs-
// preview awareness at all: the caller decides what to render as children
// (editable cards in a constructor, read-only blocks in Preview) - this
// component only ever arranges them. Unused CSS vars for a given layout are
// harmless (e.g. grid ignores --container-min-item-width), so no per-layout
// branching is needed here beyond the class name itself - see
// variables/containerLayoutTypes.js for what each layout key does in CSS.
//
// Every child gets wrapped in `.container-layout-item` - not decoration,
// a defensive `min-width:0`/`min-height:0` so a grid/flex child containing
// unpredictable content (text, a table, an embedded exercise) can't blow
// out its cell, regardless of what the child's own markup does or doesn't
// set. Callers layer any further per-item chrome (e.g. Preview's light
// card border) via an extra class on their own child markup, not here.
export default function ContainerLayout({ layout, config, children }) {
   const cfg = config || {};
   const justify = cfg.justify || defaultJustifyFor(layout);
   const style = {
      '--container-columns': cfg.columns || 2,
      '--container-gap': toCssLength(cfg.gap, '0px'),
      '--container-min-item-width': toCssLength(cfg.minItemWidth, '0px'),
      '--container-justify': getJustifyCssValue(justify),
      '--container-item-grow': justify === 'stretch' ? 1 : 0,
   };
   if (cfg.itemWidth) {
      style['--container-item-width'] = toCssLength(cfg.itemWidth);
   }

   return (
      <div className={'container-layout container-layout-' + layout} style={style}>
         {Children.map(children, (child) => <div className='container-layout-item'>{child}</div>)}
      </div>
   );
}
